// LF360-1811 — an invalid draft must still be persisted (so "Discard changes"
// stays available), which means we have to record WHETHER it is valid. The
// validity signal reaches the page in two different shapes:
//
//   - the node editor calls `update(graph, errors)` with an ARRAY of errors;
//   - the AI chatbot calls it with the `validateScenarioStructure` result,
//     an OBJECT `{ isValid, errors }` (scenario-editor.jsx -> update?.(...)).
//
// Reading `.length` on the object shape yields `undefined`, which would mark
// every chatbot edit invalid; assuming `true` for unknown shapes would let an
// invalid graph be activated. So: normalise both, and return null for anything
// unrecognised so the caller can FAIL CLOSED (skip the save rather than guess).

/**
 * @param {unknown} validation array of errors, or { isValid, errors }
 * @returns {boolean|null} true/false when the shape is known, null otherwise
 */
export const resolveValidationIsValid = (validation) => {
  if (Array.isArray(validation)) {
    return validation.length === 0;
  }

  if (validation && typeof validation.isValid === 'boolean') {
    return validation.isValid;
  }

  return null;
};

/**
 * A real "empty" scenario still contains Start + Finish nodes, so an empty
 * object is a transient/error emission from the editor and must never be
 * persisted over an existing draft.
 *
 * @param {unknown} graph serialized scenario graph (id -> node map)
 */
export const isPersistableGraph = (graph) =>
  Boolean(graph) && typeof graph === 'object' && Object.keys(graph).length > 0;
